// extracted by mini-css-extract-plugin
export var footer = "_s3-0";
export var inherit = "_s3-1";
export var input = "_s3-2";
export var modalContent = "_s3-3";
export var quillEditor = "_s3-4";
export var subtitle = "_s3-5";